import { initializeSuccess } from './initialize';
import initializeGateways from './initializeGateways';
import * as sharedTypes from 'src/actions/shared/sharedTypes';
import { login } from 'src/actions/auth/authSlice';
import { update as updateRoleFeatures } from 'src/actions/auth/roleFeaturesSlice';
import { fetchAll as fetchOrganizations } from 'src/actions/imitate/organizationsResource';
import analytics from '@ad-scripts/lib/analytics';

const initializeApp: sharedTypes.AppThunk =
  () =>
  async (dispatch, getState, { backend, gateways, stores }) => {
    const auth = stores.auth.get();
    if (auth && auth.userId) {
      const navigateToLogin = () => {
        window.location.replace(`/user/login?fromPath=${window.location.pathname}`);
      };
      const navigateToHome = () => {
        window.location.replace('/home');
      };

      backend.connect('cookie', auth.orgId); // No idea why this thing is hardcoded as 'cookie'
      initializeGateways(gateways, auth);
      analytics.enableDefault();
      analytics.setUser({ id: auth.userId });
      dispatch(login(auth));
      // @ts-ignore
      dispatch(updateRoleFeatures(auth));
      dispatch(initializeSuccess());

      backend.on('unauthorized', navigateToLogin);
      backend.on('disconnect-rate-limit', navigateToHome);
      gateways.agentStatus.subscribe({ agentId: auth.userId });
    } else {
      if (window.location.pathname !== '/user/login') {
        if (window.location.pathname.startsWith('/admin/imitate')) {
          dispatch(fetchOrganizations());
        } else {
          window.location.replace(`/user/login?fromPath=${window.location.pathname}`);
        }
      }
    }
  };

export default initializeApp;
